import { isSerialNumber } from '~/features/devices/utils/deviceQuery';

export const createVinOrSerialNumberFilters = (searchValue) => {
    const trimmedValue = searchValue.trim();
    
    if (trimmedValue.length === 0) {
        return {
            serialNumberPrefix: undefined,
            vinPrefix: undefined,
        };
    }
    
    if (isSerialNumber(trimmedValue)) {
        return {
            serialNumberPrefix: trimmedValue.toLowerCase(),
            vinPrefix: undefined,
        };
    } else {
        return {
            vinPrefix: trimmedValue.toUpperCase(),
            serialNumberPrefix: undefined,
        };
    }
};